import React, { useEffect, useState } from "react";
import { Snackbar, Alert, AlertColor } from "@mui/material";

interface AlertToastProps {
  message: string;
  type?: AlertColor; // "success" | "error" | "warning" | "info"
  open: boolean;
  onClose: () => void;
  duration?: number; // Auto-close duration in ms
}

const AlertToast: React.FC<AlertToastProps> = ({
  message,
  type = "info",
  open,
  onClose,
  duration = 5000, // Default 5 seconds
}) => {
  const [isOpen, setIsOpen] = useState(open);

  useEffect(() => {
    setIsOpen(open);
  }, [open]);


  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === 'clickaway') return; // Ignore clickaway dismissals if needed
    setIsOpen(false);
    onClose();
  };

  return (
    <Snackbar
      open={isOpen}
      autoHideDuration={duration}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert onClose={handleClose} severity={type} variant="filled">
        {message}
      </Alert>
    </Snackbar>

  );
};

export default AlertToast;
